import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import FunctionGeneral from '../functionsGeneral';

function compareDateEqualsIPOProyeccion(dateIPO, DateProyeccion) {
    try {
        DateProyeccion = new FunctionGeneral()
            .formatFecha(DateProyeccion.split('T')[0].split('-'))
            .split('/');
        dateIPO = dateIPO.split('/');
    } catch {
        return false;
    }
    if (dateIPO.length !== 3 || DateProyeccion.length !== 3) return false;
    if (DateProyeccion[1] === dateIPO[1] && DateProyeccion[2] === dateIPO[2])
        return true;
    return false;
}
function compareDateIPOProyeccion(dateIPO, DateProyeccion) {
    try {
        DateProyeccion = new FunctionGeneral()
            .formatFecha(DateProyeccion.split('T')[0].split('-'))
            .split('/');
        dateIPO = dateIPO.split('/');
    } catch {
        return false;
    }
    if (dateIPO.length !== 3 || DateProyeccion.length !== 3) return false;
    if (
        (DateProyeccion[1] === dateIPO[1] &&
            DateProyeccion[2] === dateIPO[2]) ||
        dateIPO[2] < DateProyeccion[2] ||
        (dateIPO[2] === DateProyeccion[2] && dateIPO[1] < DateProyeccion[1])
    )
        return true;
    return false;
}
function compareDateEqualsHoyProyeccion(DateProyeccion, DateProyeccionNext) {
    var _fechaActual = new Date();
    try {
        DateProyeccion = new FunctionGeneral()
            .formatFecha(DateProyeccion.split('T')[0].split('-'))
            .split('/');
        DateProyeccionNext = new FunctionGeneral()
            .formatFecha(
                DateProyeccionNext.ReferenceDate.split('T')[0].split('-')
            )
            .split('/');
    } catch {
        if (DateProyeccionNext === undefined) {
            if (
                parseInt(DateProyeccion[2]) === _fechaActual.getFullYear() &&
                parseInt(DateProyeccion[1]) === _fechaActual.getMonth() + 1 &&
                parseInt(DateProyeccion[0]) <= _fechaActual.getDate()
            )
                return true;
        }
        return false;
    }

    if (DateProyeccion.length !== 3) return false;
    if (
        parseInt(DateProyeccion[2]) === _fechaActual.getFullYear() &&
        parseInt(DateProyeccion[1]) === _fechaActual.getMonth() &&
        !(parseInt(DateProyeccionNext[0]) <= _fechaActual.getDate())
    )
        return true;
    else if (
        parseInt(DateProyeccion[2]) === _fechaActual.getFullYear() &&
        parseInt(DateProyeccion[1]) === _fechaActual.getMonth() + 1 &&
        parseInt(DateProyeccion[0]) <= _fechaActual.getDate()
    )
        return true;

    return false;
}

function PrintProyecciones(props) {
    const [scrollTable, setscrollTable] = useState(false);
    const [item, setitem] = useState([]);
    const [itemAntesIPO, setitemAntesIPOitem] = useState([]);
    const [opt_CPC_NEXT, setopt_CPC_NEXT] = useState(true);

    useEffect(() => {
        if (props.dataProyeccion.length > 0 && props.dataContrato !== []) {
            var dataProyeccion = [];
            var item = [];
            var itemAntesIPO = [];
            var fechAntes = false;
            var opt_CPC_NEXT = true; //next
            if (props.rowSelect.ProductBoxId !== '158 ') {
                opt_CPC_NEXT = false;
                dataProyeccion = new FunctionGeneral().addCPCFeeNumber(
                    props.dataProyeccion,
                    props.dataContrato,
                    props.rowSelect
                );
            } else dataProyeccion = props.dataProyeccion;
            if (dataProyeccion.length > 0)
                if (
                    props.rowSelect.FinancialOperationCIASEG ===
                    dataProyeccion[0].FinancialOperation
                ) {
                    dataProyeccion.forEach((element, index) => {
                        if (
                            opt_CPC_NEXT &&
                            compareDateIPOProyeccion(
                                props.rowSelect.IPODate,
                                element.ReferenceDate
                            )
                        )
                            fechAntes = true;
                        if (fechAntes) {
                            item.push(
                                <div
                                    style={{ margin: 'auto', width: '24px' }}
                                    className="tooltipProyeccion"
                                    key={
                                        props.rowSelect.FinancialOperationCode +
                                        '_' +
                                        item.length +
                                        element.FeeNumber
                                    }
                                >
                                    <div
                                        className="colorBlue circleProyeccion js-tooltip c-tooltip"
                                        data-template={
                                            props.rowSelect
                                                .FinancialOperationCode +
                                            '_' +
                                            item.length +
                                            element.ReferenceId +
                                            element.ReferenceDate
                                        }
                                    >
                                        {element.FeeNumber}
                                    </div>
                                    {compareDateEqualsHoyProyeccion(
                                        element.ReferenceDate,
                                        dataProyeccion[index + 1]
                                    ) && <div className="arrowProyeccion" />}
                                    {compareDateEqualsHoyProyeccion(
                                        element.ReferenceDate,
                                        dataProyeccion[index + 1]
                                    ) && (
                                        <div className="diaProyeccion">Hoy</div>
                                    )}

                                    {opt_CPC_NEXT &&
                                        compareDateEqualsIPOProyeccion(
                                            props.rowSelect.IPODate,
                                            element.ReferenceDate
                                        ) && (
                                            <div className=" color-AA arrowProyeccion" />
                                        )}
                                    {opt_CPC_NEXT &&
                                        compareDateEqualsIPOProyeccion(
                                            props.rowSelect.IPODate,
                                            element.ReferenceDate
                                        ) && (
                                            <div className="color-AA u-text-white diaProyeccion">
                                                IPO
                                            </div>
                                        )}
                                    <div
                                        id={
                                            props.rowSelect
                                                .FinancialOperationCode +
                                            '_' +
                                            item.length +
                                            element.ReferenceId +
                                            element.ReferenceDate
                                        }
                                        style={{ display: 'none' }}
                                    >
                                        <Table
                                            className="tablaProyeccion"
                                            key={
                                                props.rowSelect
                                                    .FinancialOperationCode +
                                                '_Proyecciones'
                                            }
                                        >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        style={{
                                                            width: '65px',
                                                            maxWidth: '65px',
                                                        }}
                                                    >
                                                        Cuota
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            width: '120px',
                                                            maxWidth: '120px',
                                                            marginLeft: '5px',
                                                        }}
                                                    >
                                                        Fecha
                                                    </TableCell>
                                                    {opt_CPC_NEXT && (
                                                        <TableCell
                                                            style={{
                                                                width: '120px',
                                                                maxWidth:
                                                                    '120px',
                                                            }}
                                                        >
                                                            V.Compra
                                                        </TableCell>
                                                    )}
                                                    {opt_CPC_NEXT && (
                                                        <TableCell
                                                            style={{
                                                                width: '70px',
                                                                maxWidth:
                                                                    '70px',
                                                            }}
                                                        >
                                                            Puntos
                                                        </TableCell>
                                                    )}
                                                    <TableCell
                                                        style={{
                                                            width: '25px',
                                                            maxWidth: '25px',
                                                        }}
                                                    >
                                                        <div
                                                            className="c-icon c-icon--[semantic-user]"
                                                            style={{
                                                                fontSize:
                                                                    '20px',
                                                                fontWeight:
                                                                    'bold',
                                                                marginRight:
                                                                    '7px',
                                                            }}
                                                        ></div>
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            width: '25px',
                                                            maxWidth: '25px',
                                                        }}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="19.006"
                                                            height="15"
                                                            viewBox="0 0 19.006 15"
                                                        >
                                                            <path
                                                                d="M17.578,4.083h-2.1l-.585-1.517A3.921,3.921,0,0,0,11.232,0H6.767A3.923,3.923,0,0,0,3.112,2.567L2.527,4.083H.422a.434.434,0,0,0-.409.544L.224,5.5a.425.425,0,0,0,.409.331h.706a2.353,2.353,0,0,0-.776,1.75v1.75a2.364,2.364,0,0,0,.563,1.529v1.971A1.147,1.147,0,0,0,2.25,14H3.375A1.147,1.147,0,0,0,4.5,12.833V11.667h9v1.167A1.147,1.147,0,0,0,14.625,14H15.75a1.147,1.147,0,0,0,1.125-1.167V10.862a2.362,2.362,0,0,0,.563-1.529V7.583a2.354,2.354,0,0,0-.776-1.75h.706a.425.425,0,0,0,.409-.331l.211-.875A.434.434,0,0,0,17.578,4.083ZM5.02,3.07A1.8,1.8,0,0,1,6.661,1.75h4.677A1.8,1.8,0,0,1,12.98,3.07l.734,2.18H4.286ZM4.086,9.617A1.267,1.267,0,0,1,2.714,8.308,1.267,1.267,0,0,1,4.086,7,2.585,2.585,0,0,1,6.143,8.963C6.143,9.748,4.909,9.617,4.086,9.617Zm9.829,0c-.823,0-2.057.131-2.057-.654A2.585,2.585,0,0,1,13.914,7a1.267,1.267,0,0,1,1.371,1.308,1.267,1.267,0,0,1-1.371,1.308Z"
                                                                transform="translate(0.503 0.5)"
                                                                fill="#fff"
                                                                stroke="black"
                                                                strokeWidth="1"
                                                            />
                                                        </svg>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell
                                                        style={{
                                                            fontWeight: 'bold',
                                                        }}
                                                        className="colorBlue"
                                                    >
                                                        <span
                                                            className="u-float-left colorBlue"
                                                            style={{
                                                                lineHeight:
                                                                    '26px',
                                                                fontSize:
                                                                    '19px',
                                                            }}
                                                        >
                                                            {element.FeeNumber}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell>
                                                        {new FunctionGeneral().formatFecha(
                                                            element.ReferenceDate.split(
                                                                'T'
                                                            )[0].split('-')
                                                        )}
                                                    </TableCell>
                                                    {opt_CPC_NEXT && (
                                                        <TableCell>
                                                            {new FunctionGeneral().formatNum(
                                                                element.PendingCapital
                                                            )}
                                                            €
                                                        </TableCell>
                                                    )}
                                                    {opt_CPC_NEXT && (
                                                        <TableCell>
                                                            {new FunctionGeneral().formatNum(
                                                                element.ClientNextPoint
                                                            )}
                                                        </TableCell>
                                                    )}
                                                    <TableCell>
                                                        {new FunctionGeneral().EsferaColor(
                                                            element.CustomerScoring
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        {new FunctionGeneral().EsferaColor(
                                                            element.VehicleScoring
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </div>
                                </div>
                            );
                        } else {
                            itemAntesIPO.push(
                                <div
                                    style={{ margin: 'auto', width: '24px' }}
                                    className="tooltipProyeccion"
                                    key={
                                        props.rowSelect.FinancialOperationCode +
                                        '_' +
                                        itemAntesIPO.length +
                                        '_' +
                                        item.length +
                                        element.FeeNumber
                                    }
                                >
                                    <div
                                        className="colorBlue circleProyeccion js-tooltip c-tooltip"
                                        data-template={
                                            props.rowSelect
                                                .FinancialOperationCode +
                                            '_' +
                                            itemAntesIPO.length +
                                            '_' +
                                            item.length +
                                            element.ReferenceId +
                                            element.ReferenceDate
                                        }
                                    >
                                        {element.FeeNumber}
                                    </div>
                                    {compareDateEqualsHoyProyeccion(
                                        element.ReferenceDate,
                                        dataProyeccion[index + 1]
                                    ) && <div className="arrowProyeccion" />}
                                    {compareDateEqualsHoyProyeccion(
                                        element.ReferenceDate,
                                        dataProyeccion[index + 1]
                                    ) && (
                                        <div className="diaProyeccion">Hoy</div>
                                    )}
                                    <div
                                        id={
                                            props.rowSelect
                                                .FinancialOperationCode +
                                            '_' +
                                            itemAntesIPO.length +
                                            '_' +
                                            item.length +
                                            element.ReferenceId +
                                            element.ReferenceDate
                                        }
                                        style={{ display: 'none' }}
                                    >
                                        <Table
                                            className="tablaProyeccion"
                                            key={
                                                props.rowSelect
                                                    .FinancialOperationCode
                                            }
                                        >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell
                                                        style={{
                                                            width: '65px',
                                                            maxWidth: '65px',
                                                        }}
                                                    >
                                                        Cuota
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            width: '120px',
                                                            maxWidth: '120px',
                                                            marginLeft: '5px',
                                                        }}
                                                    >
                                                        Fecha
                                                    </TableCell>
                                                    {opt_CPC_NEXT && (
                                                        <TableCell
                                                            style={{
                                                                width: '120px',
                                                                maxWidth:
                                                                    '120px',
                                                            }}
                                                        >
                                                            V.Compra
                                                        </TableCell>
                                                    )}
                                                    {opt_CPC_NEXT && (
                                                        <TableCell
                                                            style={{
                                                                width: '70px',
                                                                maxWidth:
                                                                    '70px',
                                                            }}
                                                        >
                                                            Puntos
                                                        </TableCell>
                                                    )}
                                                    <TableCell
                                                        style={{
                                                            width: '25px',
                                                            maxWidth: '25px',
                                                        }}
                                                    >
                                                        <div
                                                            className="c-icon c-icon--[semantic-user]"
                                                            style={{
                                                                fontSize:
                                                                    '20px',
                                                                fontWeight:
                                                                    'bold',
                                                                marginRight:
                                                                    '7px',
                                                            }}
                                                        ></div>
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            width: '25px',
                                                            maxWidth: '25px',
                                                        }}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="19.006"
                                                            height="15"
                                                            viewBox="0 0 19.006 15"
                                                        >
                                                            <path
                                                                d="M17.578,4.083h-2.1l-.585-1.517A3.921,3.921,0,0,0,11.232,0H6.767A3.923,3.923,0,0,0,3.112,2.567L2.527,4.083H.422a.434.434,0,0,0-.409.544L.224,5.5a.425.425,0,0,0,.409.331h.706a2.353,2.353,0,0,0-.776,1.75v1.75a2.364,2.364,0,0,0,.563,1.529v1.971A1.147,1.147,0,0,0,2.25,14H3.375A1.147,1.147,0,0,0,4.5,12.833V11.667h9v1.167A1.147,1.147,0,0,0,14.625,14H15.75a1.147,1.147,0,0,0,1.125-1.167V10.862a2.362,2.362,0,0,0,.563-1.529V7.583a2.354,2.354,0,0,0-.776-1.75h.706a.425.425,0,0,0,.409-.331l.211-.875A.434.434,0,0,0,17.578,4.083ZM5.02,3.07A1.8,1.8,0,0,1,6.661,1.75h4.677A1.8,1.8,0,0,1,12.98,3.07l.734,2.18H4.286ZM4.086,9.617A1.267,1.267,0,0,1,2.714,8.308,1.267,1.267,0,0,1,4.086,7,2.585,2.585,0,0,1,6.143,8.963C6.143,9.748,4.909,9.617,4.086,9.617Zm9.829,0c-.823,0-2.057.131-2.057-.654A2.585,2.585,0,0,1,13.914,7a1.267,1.267,0,0,1,1.371,1.308,1.267,1.267,0,0,1-1.371,1.308Z"
                                                                transform="translate(0.503 0.5)"
                                                                fill="#fff"
                                                                stroke="black"
                                                                strokeWidth="1"
                                                            />
                                                        </svg>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow
                                                    key={
                                                        element.FeeNumber +
                                                        element.FinancialOperation
                                                    }
                                                >
                                                    <TableCell
                                                        style={{
                                                            fontWeight: 'bold',
                                                        }}
                                                        className="colorBlue"
                                                    >
                                                        <span
                                                            className="u-float-left colorBlue"
                                                            style={{
                                                                lineHeight:
                                                                    '26px',
                                                                fontSize:
                                                                    '19px',
                                                            }}
                                                        >
                                                            {element.FeeNumber}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell>
                                                        {new FunctionGeneral().formatFecha(
                                                            element.ReferenceDate.split(
                                                                'T'
                                                            )[0].split('-')
                                                        )}
                                                    </TableCell>
                                                    {opt_CPC_NEXT && (
                                                        <TableCell>
                                                            {new FunctionGeneral().formatNum(
                                                                element.PendingCapital
                                                            )}
                                                            €
                                                        </TableCell>
                                                    )}
                                                    {opt_CPC_NEXT && (
                                                        <TableCell>
                                                            {new FunctionGeneral().formatNum(
                                                                element.ClientNextPoint
                                                            )}
                                                        </TableCell>
                                                    )}
                                                    <TableCell>
                                                        {new FunctionGeneral().EsferaColor(
                                                            element.CustomerScoring
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        {new FunctionGeneral().EsferaColor(
                                                            element.VehicleScoring
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </div>
                                </div>
                            );
                        }
                    });
                }
            setitem(item);
            setitemAntesIPOitem(itemAntesIPO);
            setopt_CPC_NEXT(opt_CPC_NEXT);
        } else {
            setitem([]);
            setitemAntesIPOitem([]);
        }
    }, [props.dataProyeccion, props.dataContrato]);

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, [item]);

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, [itemAntesIPO]);

    const printProyeccion = () => {
        var tamaoFee = 30 / (props.dataProyeccion.length + 1) + 'px';
        document.documentElement.style.setProperty(
            '--color-tippy-tooltip',
            'white'
        );
        var itemLenggDesdeIPO =
            (item.length * 100) / (item.length + itemAntesIPO.length);
        return (
            <div>
                <div
                    className="gridContainer"
                    style={{
                        paddingBottom:
                            opt_CPC_NEXT && props.dataProyeccion.length > 0
                                ? ''
                                : '35px',
                        minHeight: window.innerWidth <= 720 ? '465px' : 'auto',
                    }}
                >
                    <div className="o-layout__item u-1/1">
                        {item.length > 0 || itemAntesIPO.length > 0 ? (
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 20.035 20.04"
                                >
                                    <path
                                        d="M18.333,16.667v-12h-4v12H13v-8H9v8H7.667v-4h-4v4H2.333V2H1V18H19.667V16.667Zm-12,0H5V14H6.333Zm5.333,0H10.333V10h1.333Zm5.333,0H15.667V6H17Z"
                                        transform="translate(-1 -2)"
                                        fill={'rgb(0, 70, 102)'}
                                    />
                                </svg>
                                <label className="u-h3 u-ml-xsmall">
                                    Proyección
                                </label>
                            </span>
                        ) : (
                            <div
                                style={{
                                    backgroundColor: 'rgb(216, 216, 216)',
                                    height: '25px',
                                    width: '30%',
                                    float: 'left',
                                }}
                            >
                                {' '}
                            </div>
                        )}
                        {window.innerWidth > 720 && (
                            <div className="sg-component-variant  o-layout--center u-float-right u-p-small u-mb-small">
                                <button
                                    className="c-btn  c-btn--link  c-btn--secondary"
                                    onClick={() =>
                                        props.setModalProyeccion(true)
                                    }
                                >
                                    <i
                                        className="c-btn__icon c-icon  c-icon--[semantic-forward]"
                                        aria-hidden="true"
                                        role="img"
                                    ></i>
                                    <span className="c-btn__text">
                                        VER TODAS LAS CUOTAS
                                    </span>
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="o-layout__item u-1/1 u-hide@s">
                        <div style={{ display: 'flex', height: '30px' }}>
                            <div
                                className="u-float-left"
                                style={{
                                    width: 100 - itemLenggDesdeIPO + '%',
                                    backgroundColor: '#D8D8D8',
                                    height: '8px',
                                    paddingLeft: tamaoFee,
                                    display: 'flex',
                                }}
                            >
                                {itemAntesIPO}
                            </div>
                            <div
                                className={
                                    item.length > 0
                                        ? 'u-float-left background-color-blue'
                                        : 'u-float-left'
                                }
                                style={{
                                    width: itemLenggDesdeIPO + '%',
                                    marginRight: '20px',
                                    height: '8px',
                                    paddingLeft: tamaoFee,
                                    display: 'flex',
                                }}
                            >
                                {item}
                            </div>
                        </div>

                        {opt_CPC_NEXT &&
                            props.dataProyeccion.length > 0 &&
                            (item.length > 0 || itemAntesIPO.length > 0) && (
                                <div
                                    style={{
                                        display: 'flex',
                                        height: '30px',
                                        marginTop: '35px',
                                    }}
                                >
                                    <div
                                        className="u-float-left"
                                        style={{
                                            width: '100px',
                                            backgroundColor: '#D8D8D8',
                                            height: '8px',
                                            paddingLeft: tamaoFee,
                                            display: 'flex',
                                        }}
                                    >
                                        <span
                                            style={{
                                                margin: 'auto',
                                                marginTop: '15px',
                                            }}
                                        >
                                            {' '}
                                            Antes IPO
                                        </span>
                                    </div>
                                    <div
                                        className="u-float-left background-color-blue"
                                        style={{
                                            width: '100px',
                                            marginRight: '20px',
                                            height: '8px',
                                            paddingLeft: tamaoFee,
                                            display: 'flex',
                                        }}
                                    >
                                        <span style={{ marginTop: '15px' }}>
                                            {' '}
                                            Despues IPO
                                        </span>
                                    </div>
                                </div>
                            )}
                    </div>
                    <div className="u-1/1 u-hide@s-up">
                        <div
                            className="tablaModalProyeccion"
                            style={{
                                overflowY: scrollTable ? 'hidden' : 'auto',
                                backgroundColor:
                                    item.length === 0 &&
                                    itemAntesIPO.length === 0
                                        ? 'rgb(216, 216, 216)'
                                        : '',
                            }}
                        >
                            <Table>
                                <TableHead>
                                    {(item.length > 0 ||
                                        itemAntesIPO.length > 0) && (
                                        <TableRow>
                                            <TableCell
                                                style={{
                                                    minWidth: '25px',
                                                    maxWidth: '25px',
                                                }}
                                            ></TableCell>
                                            <TableCell
                                                style={{
                                                    minWidth: '110px',
                                                    maxWidth: '110px',
                                                }}
                                            >
                                                Cuota
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    minWidth: '100px',
                                                    maxWidth: '100px',
                                                }}
                                            >
                                                Fecha
                                            </TableCell>
                                            {opt_CPC_NEXT && (
                                                <TableCell
                                                    style={{
                                                        minWidth: '120px',
                                                        maxWidth: '120px',
                                                    }}
                                                >
                                                    Valor de Compra
                                                </TableCell>
                                            )}
                                            {opt_CPC_NEXT && (
                                                <TableCell
                                                    style={{
                                                        minWidth: '70px',
                                                        maxWidth: '70px',
                                                    }}
                                                >
                                                    Puntos
                                                </TableCell>
                                            )}
                                            <TableCell
                                                style={{
                                                    width: '25px',
                                                    maxWidth: '25px',
                                                }}
                                            >
                                                <div
                                                    className="c-icon c-icon--[semantic-user]"
                                                    style={{
                                                        fontSize: '20px',
                                                        fontWeight: 'bold',
                                                        marginRight: '7px',
                                                    }}
                                                ></div>
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    width: '25px',
                                                    maxWidth: '25px',
                                                }}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="19.006"
                                                    height="15"
                                                    viewBox="0 0 19.006 15"
                                                >
                                                    <path
                                                        d="M17.578,4.083h-2.1l-.585-1.517A3.921,3.921,0,0,0,11.232,0H6.767A3.923,3.923,0,0,0,3.112,2.567L2.527,4.083H.422a.434.434,0,0,0-.409.544L.224,5.5a.425.425,0,0,0,.409.331h.706a2.353,2.353,0,0,0-.776,1.75v1.75a2.364,2.364,0,0,0,.563,1.529v1.971A1.147,1.147,0,0,0,2.25,14H3.375A1.147,1.147,0,0,0,4.5,12.833V11.667h9v1.167A1.147,1.147,0,0,0,14.625,14H15.75a1.147,1.147,0,0,0,1.125-1.167V10.862a2.362,2.362,0,0,0,.563-1.529V7.583a2.354,2.354,0,0,0-.776-1.75h.706a.425.425,0,0,0,.409-.331l.211-.875A.434.434,0,0,0,17.578,4.083ZM5.02,3.07A1.8,1.8,0,0,1,6.661,1.75h4.677A1.8,1.8,0,0,1,12.98,3.07l.734,2.18H4.286ZM4.086,9.617A1.267,1.267,0,0,1,2.714,8.308,1.267,1.267,0,0,1,4.086,7,2.585,2.585,0,0,1,6.143,8.963C6.143,9.748,4.909,9.617,4.086,9.617Zm9.829,0c-.823,0-2.057.131-2.057-.654A2.585,2.585,0,0,1,13.914,7a1.267,1.267,0,0,1,1.371,1.308,1.267,1.267,0,0,1-1.371,1.308Z"
                                                        transform="translate(0.503 0.5)"
                                                        fill="#fff"
                                                        stroke="black"
                                                        strokeWidth="1"
                                                    />
                                                </svg>
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    minWidth: '25px',
                                                    maxWidth: '25px',
                                                }}
                                            ></TableCell>
                                        </TableRow>
                                    )}
                                </TableHead>
                                <TableBody>
                                    {(item.length > 0 ||
                                        itemAntesIPO.length > 0) &&
                                        props.dataProyeccion.map(
                                            (row, index) => (
                                                <TableRow
                                                    key={
                                                        row.FeeNumber +
                                                        props.indiceRow +
                                                        row.ReferenceDate
                                                    }
                                                >
                                                    <TableCell className="borderRadiusProyeccionleft"></TableCell>
                                                    <TableCell
                                                        style={
                                                            compareDateEqualsHoyProyeccion(
                                                                row.ReferenceDate,
                                                                props
                                                                    .dataProyeccion[
                                                                    index + 1
                                                                ]
                                                            )
                                                                ? {
                                                                      verticalAlign:
                                                                          'bottom',
                                                                      fontWeight:
                                                                          'bold',
                                                                  }
                                                                : {
                                                                      fontWeight:
                                                                          'bold',
                                                                  }
                                                        }
                                                        className="colorBlue"
                                                    >
                                                        <span
                                                            className="u-float-left"
                                                            style={{
                                                                lineHeight:
                                                                    '26px',
                                                            }}
                                                        >
                                                            {row.FeeNumber}
                                                        </span>
                                                        {compareDateEqualsHoyProyeccion(
                                                            row.ReferenceDate,
                                                            props
                                                                .dataProyeccion[
                                                                index + 1
                                                            ]
                                                        ) && (
                                                            <div
                                                                className="diaProyeccion u-float-left"
                                                                style={{
                                                                    bottom: '0',
                                                                    left: '15px',
                                                                }}
                                                            >
                                                                Hoy
                                                            </div>
                                                        )}
                                                        {opt_CPC_NEXT &&
                                                            compareDateEqualsIPOProyeccion(
                                                                props.rowSelect
                                                                    .IPODate,
                                                                row.ReferenceDate
                                                            ) && (
                                                                <div
                                                                    className="color-AA diaProyeccion u-text-white u-float-left"
                                                                    style={{
                                                                        bottom: '0',
                                                                        left: '15px',
                                                                    }}
                                                                >
                                                                    IPO
                                                                </div>
                                                            )}
                                                    </TableCell>
                                                    <TableCell>
                                                        <span
                                                            style={{
                                                                lineHeight:
                                                                    '26px',
                                                            }}
                                                        >
                                                            {new FunctionGeneral().formatFecha(
                                                                row.ReferenceDate.split(
                                                                    'T'
                                                                )[0].split('-')
                                                            )}
                                                        </span>
                                                    </TableCell>
                                                    {opt_CPC_NEXT && (
                                                        <TableCell>
                                                            {new FunctionGeneral().formatNum(
                                                                row.PendingCapital
                                                            )}{' '}
                                                            €
                                                        </TableCell>
                                                    )}
                                                    {opt_CPC_NEXT && (
                                                        <TableCell>
                                                            {new FunctionGeneral().formatNum(
                                                                row.ClientNextPoint
                                                            )}
                                                        </TableCell>
                                                    )}
                                                    <TableCell>
                                                        {new FunctionGeneral().EsferaColor(
                                                            row.CustomerScoring
                                                        )}
                                                    </TableCell>
                                                    <TableCell>
                                                        {new FunctionGeneral().EsferaColor(
                                                            row.VehicleScoring
                                                        )}
                                                    </TableCell>
                                                    <TableCell className="borderRadiusProyeccionright"></TableCell>
                                                </TableRow>
                                            )
                                        )}
                                </TableBody>
                            </Table>
                        </div>
                        {false && props.dataProyeccion.length > 5 && (
                            <div className="o-layout__item u-1/1">
                                <span
                                    className="back-to-matrix"
                                    onClick={() => setscrollTable(!scrollTable)}
                                >
                                    <label
                                        className="iconHover"
                                        style={{
                                            marginTop: '10px',
                                            textDecoration: 'underline',
                                            paddingRight: '25px',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        Ver
                                        {scrollTable
                                            ? ' todas las '
                                            : ' menos '}
                                        cuotas
                                    </label>
                                </span>
                            </div>
                        )}
                    </div>
                </div>
                <div
                    className="gridContainer2"
                    style={
                        item.length > 0 || itemAntesIPO.length > 0
                            ? { display: 'none' }
                            : {}
                    }
                ></div>
            </div>
        );
    };
    return <div>{printProyeccion()}</div>;
}
export default withRouter(PrintProyecciones);
